import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const ShopDetailsSource = {
  fetch: function() {
    return axios.get(`${API_BASE}/shop`)
      .then(resp => resp.data)
  }
}

export default ShopDetailsSource



// WEBPACK FOOTER //
// ./app/sources/ShopDetailsSource.js